import React from 'react';

//axios
import axios from 'axios';
import axiosUrl from '../../axios/url';


export default function SignUp(param) {

    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [password2, setPassword2] = React.useState('');
    const [organization , setOrganization] = React.useState('');

    // handle function
    function handleUsername(e) { setUsername(trim(e.target.value)); }
    function handleOrganization(e) { setOrganization(trim(e.target.value)); }
    function handlePassword(e) { setPassword(trim(e.target.value)); }
    function handlePassword2(e) { setPassword2(trim(e.target.value)); }
    
    function useSave() {
        if(username === '' || password === '' || password2 === '' || organization === '') { alert("모든 항목을 입력하세요."); return;} 
        if(password !== password2) { alert('비밀번호가 일치하지 않습니다. 다시 입력하세요.'); return; }
        if(!validateEmailAddress(username)) { alert('사용자 이름은 이메일 형식입니다.'); return; }

        //if(!window.confirm(username + '님 CMS에 가입하시겠습니까?')) return;
        
        goSignUp();
    }

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }

    // 이메일 validation
    function validateEmailAddress(email) {
        var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(email).toLowerCase());
   }


    // 가입하기
    async function goSignUp(){
        var url = axiosUrl.signup;
        await axios.post(url,{
            username: username,
            password: password,
            organization : {
                name: organization
            }
        },{
            headers: {
            'Content-Type': 'application/json',
           }
        } )
        .then( response => {
            alert('CMS에 가입하셨습니다. 환영합니다!');
            console.error('[MEDIEX_CMS_2019_ERROR] SignUp.goSignup - SUCCESS');
            window.location.href='/signin';
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] SignUp.goSignup - ' + e);
                alert(e.response.data.error.message);
        });
    }


    React.useEffect(() => {

    });


    return(


        <div className="register-box">
            <div className="register-logo">
                <a href="/"><b>myHealth</b>CMS</a>
            </div>

            <div className="card">
                <div className="card-body register-card-body">
                    <p className="login-box-msg">새 멤버로 가입</p>

                    <div className="input-group mb-3">
                        <input type="email" className="form-control" placeholder="아이디" onChange={handleUsername} />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fas fa-envelope"></span>
                            </div>
                        </div>
                    </div>
                    <div className="input-group mb-3">
                        <input className="form-control" placeholder="조직명"  onChange={handleOrganization}/>
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <i className="nav-icon fas fa-sitemap"/>
                            </div>
                        </div>
                    </div>
                    
                    <div className="input-group mb-3">
                        <input type="password" className="form-control" placeholder="비밀번호" onChange={handlePassword} />
                        <div className="input-group-append">
                            <div className="input-group-text">
                            <span className="fas fa-lock"></span>
                            </div>
                        </div>
                    </div>
                    <div className="input-group mb-3">
                        <input type="password" className="form-control" placeholder="비밀번호 확인" onChange={handlePassword2} />
                        <div className="input-group-append">
                            <div className="input-group-text">
                            <span className="fas fa-lock"></span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <button type="submit" className="btn btn-primary btn-block btn-flat" onClick={useSave}>가입</button>
                        </div>
                    </div>
                </div>
             </div>
                
        </div>
      
    );
}